export default function (mills: number) {
    return new Promise(resolve => setTimeout(resolve, mills));
}
